import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import PersonIcon from "@mui/icons-material/Person";
import AddIcon from "@mui/icons-material/Add";
import Typography from "@mui/material/Typography";
import { blue } from "@mui/material/colors";
import {
  ButtonGroup,
  DialogActions,
  DialogContent,
  IconButton,
  TextField,
} from "@mui/material";
import { Circle, CircleOutlined, PhotoCamera } from "@mui/icons-material";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { DatePicker, LocalizationProvider, TimePicker } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import {
  ADD_CALENDAR_EVENT,
  REMOVE_CALENDAR_EVENT,
} from "../../Constants/reducerEvents";
const daysOfWeek = ["S", "M", "T", "W", "T", "F", "S"];
const FALSES = [false, false, false, false, false, false, false];
export default function CalendarPopup({ onClose, eventId, open }) {
  const dispatch = useDispatch();
  const eventObj = useSelector((state) =>
    state.calendar.events.find((e) => e.id === eventId)
  );
  const courses = [
    { id: null, name: "None" },
    ...useSelector((state) => state.courses),
  ];
  const [course, setCourse] = useState(null);
  const [days, setDays] = useState(FALSES);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [title, setTitle] = useState("");
  const [location, setLocation] = useState("");
  const [zoomLink, setZoomLink] = useState("");
  const [notes, setNotes] = useState("");

  const clickDay = (index) => {
    setDays((d) => d.map((a, i) => (i === index ? !a : a)));
  };
  const handleClose = () => {
    onClose();
  };
  const submit = () => {
    if (!days.some((d) => d)) return;
    const newObj = {
      id: eventId ? eventId : uuidv4(),
      name: title,
      location: location,
      zoom: zoomLink,
      notes: notes,
      startTime: startTime,
      endTime: endTime,
      days: days,
      courseId: course,
    };
    dispatch({ type: ADD_CALENDAR_EVENT, payload: newObj });
    console.log("submit", newObj);
    onClose();
  };
  const deleteEvent = () => {
    dispatch({ type: REMOVE_CALENDAR_EVENT, payload: eventId });
    onClose();
  };
  useEffect(() => {
    if (eventId && eventObj) {
      setTitle(eventObj.name);
      setLocation(eventObj.location);
      setZoomLink(eventObj.zoom);
      setNotes(eventObj.notes);
      setStartTime(eventObj.startTime);
      setEndTime(eventObj.endTime);
      setDays(eventObj.days);
      setCourse(eventObj.courseId);
    } else {
      setTitle("");
      setLocation("");
      setZoomLink("");
      setNotes("");
      setStartTime(null);
      setEndTime(null);
      setDays(FALSES);
      setCourse("");
    }
  }, [eventId, open]);

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Calendar Event</DialogTitle>
      <DialogContent>
        <TextField
          label="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <TextField
          label="Location"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
        />
        <TextField
          label="Zoom Link"
          value={zoomLink}
          onChange={(e) => setZoomLink(e.target.value)}
        />
        <TextField
          label="Notes"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <TimePicker
            label="Start Time"
            value={startTime}
            onChange={(newValue) => {
              setStartTime(newValue);
            }}
            renderInput={(params) => <TextField {...params} />}
          />
          <TimePicker
            label="End Time"
            value={endTime}
            onChange={(newValue) => {
              setEndTime(newValue);
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
        <div style={{ position: "relative" }}>
          {days.map((d, i) => (
            <IconButton onClick={() => clickDay(i)}>
              {d && <Circle color="success" />}
              {!d && <CircleOutlined />}
              <div
                style={{
                  position: "absolute",
                  fontSize: 11,
                  color: "black",
                }}
              >
                {daysOfWeek[i]}
              </div>
            </IconButton>
          ))}
        </div>
        <ButtonGroup>
          {courses.map((c) => {
            return (
              <Button
                variant={c.id === course ? "contained" : "outlined"}
                onClick={() => setCourse(c.id)}
              >
                {c.name}
              </Button>
            );
          })}
        </ButtonGroup>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="error" onClick={deleteEvent}>
          Delete
        </Button>
        <Button variant="contained" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={submit}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
